import React from 'react'
import { Button, TextIconSpacing } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'

interface Props {
  text: string
  icon?: React.ReactNode
  disabled?: boolean
  whiteThemeBackgroundColor: string
  darkThemeBackgroundColor: string
  onClick?: () => Promise<void>
  style?: React.CSSProperties
  [x: string]: any
}

const ButtonCustom: React.FC<Props> = ({ text, icon, disabled, whiteThemeBackgroundColor, darkThemeBackgroundColor, onClick, style, ...rest }) => {
  const { promiseInProgress } = usePromiseTracker()
  const { theme } = useAuth()

  return (
    <Button
      theme={disabled || promiseInProgress ? 'disabled' : 'clear'}
      disabled={disabled || promiseInProgress}
      onClick={() => (onClick ? onClick() : {})}
      style={
        disabled || promiseInProgress
          ? { ...style }
          : theme === Theme.Dark
          ? { ...style, margin: 2, backgroundColor: darkThemeBackgroundColor, color: '#FFFFFF' }
          : { ...style, margin: 2, backgroundColor: whiteThemeBackgroundColor, color: '#212121' }
      }
      {...rest}>
      <TextIconSpacing icon={icon}>{text}</TextIconSpacing>
    </Button>
  )
}

export default ButtonCustom
